export default {
  run: 'Run#',
  carton: 'Carton#',
  plant: 'Plant',
  product: 'Product Code',
  size: 'Size',
  salesOrderType: 'Sales Order Type',
  waveRunDate: 'Wave Run Date',
  qty: 'Qty',
  rfid: 'RFID',
  nfc: 'NFC',
  normal: 'Normal',
  status: 'Status',
  type: 'Type',
  illegalUPC: 'Illegal UPC',
  paramEmpty: "Param can't be empty",
  scan: 'Please scan',
  errorcode_1112: ': File name must be matched with rule',
  errorcode_1113: ': Wave run batch number already exist in database',
  errorcode_1114: ': Wave run file is duplicate',
  errorcode_1111: ': Source file is empty',
  errorcode_500: ': System error',
  errorcode_1104: 'Wave run source file config not exist',
  errorcode_1200: 'SML share folder config not exist',
  errorcode_1201: 'Wave run 1027 init dir config not exist',
  errorcode_1202: 'Copying SML 1027 wave run file occur error',
  errorcode_604: 'The carton is cancelled in wave run list.',
  tagType: 'Tag Type',
  updatedTime: 'Updated Time ',
  productQuantity: 'Product Quantity',
  noTagTypeProduct: 'Non-NFC Product',
  manualUpdateWaveRun: 'Manual Update Wave Run',
  errorcode_1501: 'File processing failed. Please check the failure folder.'
}
